import React from 'react';

function Banner(props) {
    const { bannerObject, hideBanner } = props;

    return (
        <div className='banner-container'
             onClick={hideBanner}>
            {bannerObject && bannerObject.isVideoFile ?
                <div className='banner-video-container'>
                    <video id="banner-video" loop playsInline muted autoPlay
                           width="100%" height="100%"
                           preload="auto"
                           type="video/mp4">
                        <source type="video/mp4"
                                src={'https://images.dynamify.com/order-status-logos/' + bannerObject.fileName} />
                    </video>
                </div>
                :
                <div className='banner-image-container'
                     style={{backgroundImage: "url(https://images.dynamify.com/order-status-logos/" + bannerObject.fileName + ")"}}>
                </div>
            }
        </div>
    );
}

export default Banner;
